import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { useAuth } from '@/context/AuthContext';
import AuthLayout from './AuthLayout';
import { SignInCarousel } from './components/SignInCarousel';
import { SocialLoginRow } from './components/SocialLoginRow';

export default function SignIn() {
    const { login } = useAuth();

    const handleSocialLogin = (connection: string) => {
        login({
            authorizationParams: {
                connection,
            },
        });
    };

    return (
        <AuthLayout leftPanel={<SignInCarousel />}>
            <div className="mx-auto w-full max-w-md">
                <div className="mb-8 text-center">
                    <h2 className="text-2xl font-bold tracking-tight text-foreground">
                        Acesse sua conta
                    </h2>
                    <p className="mt-2 text-sm text-muted-foreground">
                        Bem-vindo de volta! Selecione como deseja entrar.
                    </p>
                </div>

                <div className="space-y-6">
                    <SocialLoginRow onSocialLogin={handleSocialLogin} />

                    <div className="relative">
                        <div className="absolute inset-0 flex items-center">
                            <Separator />
                        </div>
                        <div className="relative flex justify-center text-xs font-medium">
                            <span className="bg-background px-4 text-muted-foreground">
                                Ou entre com seu e-mail
                            </span>
                        </div>
                    </div>

                    <Button
                        onClick={() => {
                            login();
                        }}
                        size="xl"
                        className="w-full"
                    >
                        Login com e-mail e senha
                    </Button>
                </div>

                <div className="mt-8 text-center text-sm">
                    <p className="text-muted-foreground">
                        Não tem uma conta?{' '}
                        <Link to="/sign-up" className="font-semibold text-brand hover:underline">
                            Criar conta
                        </Link>
                    </p>
                </div>
            </div>
        </AuthLayout>
    );
}
